import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { GridContainer, GridItem } from '@xing-com/grid';
import { Section } from '@xing-com/layout-primitives';
import { mediaConfined, mediaSmallOrTiny } from '@xing-com/layout-tokens';
import {
  scale250,
  space4XL,
  spaceL,
  spaceS,
  spaceXL,
  spaceXS,
  xdlColorBackgroundSecondary,
} from '@xing-com/tokens';
import { Headline, Hero, BodyCopy } from '@xing-com/typography';

const CustomSection = styled(Section)`
  padding: 0;
  width: 100vw;
  background-color: ${xdlColorBackgroundSecondary};
`;

const GridContainerBackground = styled(GridContainer)`
  width: 100vw;
  padding: ${space4XL} ${spaceL};

  @media ${mediaConfined} {
    padding: ${scale250} 0;
  }
`;

const GridItemContainer = styled(GridItem)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const HeadlineSmall = styled(Headline)`
  margin: 0 0 ${spaceXS} 0;

  @media ${mediaConfined} {
    display: none;
  }
`;

const HeadlineWide = styled(Hero)`
  margin: 0 0 ${spaceS} 0;

  @media ${mediaSmallOrTiny} {
    display: none;
  }
`;

const Subline = styled(BodyCopy)`
  margin: 0;
`;

const HiringButton = styled(Button)`
  margin-top: ${spaceXL};
`;

export const Styled = {
  CustomSection,
  GridContainerBackground,
  GridItemContainer,
  HeadlineSmall,
  HeadlineWide,
  HiringButton,
  Subline,
};
